import { cloneDeep } from "lodash";
import { checkChanged } from "./checkChanged";
import { ITlfActionUndoTlfChange, TlfContextProps } from "./interface";

/**
 * Moves backward through TLF undo history when earlier versions exist.
 *
 * @param state - Current TLF context state.
 * @param action - Undo action with an optional number of steps.
 * @returns Updated state after undoing available history entries.
 */
export const tlf_undoTlfChange = (
  state: TlfContextProps,
  action: ITlfActionUndoTlfChange,
): TlfContextProps => {
  const newState = { ...state };
  const newIx = Math.max(0, state.ixTlfDataVersion - (action.steps ?? 1));

  if (newIx !== state.ixTlfDataVersion) {
    newState.ixTlfDataVersion = newIx;
    newState.tlfData = cloneDeep(state.tlfDataVersions[newIx]);
    checkChanged(newState);
    newState.forcePushToParent = true;
  }

  return newState;
};
